import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getAccessToken } from "../../../../common/authorization/AuthorizeService";
import ElectionFileUpload from "../../../../common/electionsInputField/ElectionFileUpload";
import ElectionInputTxt from "../../../../common/electionsInputField/ElectionInput";
import Loader from "../../../../common/loader/Loader";
import { MessageContext } from "../../../../common/message";

const editCandidateFileUploadName = "editCandidateDocuments";

const CustomEditCandidate = ({
  active,
  setCandidateModalEdit,
  candidateEdit,
  dispatch,
  electionState,
  setFetchCandidatesTrigger,
}) => {
  const [valuesForm, setValuesForm] = useState({
    evidencijskiBroj: "",
    imePrezime: "",
    ustanovaZaposlenja: "",
    dokumentacija: "",
  });
  const { t } = useTranslation();
  const message = useContext(MessageContext);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (candidateEdit) {
      setValuesForm({
        evidencijskiBroj: candidateEdit.evidencijskiBrojEhkms,
        imePrezime: candidateEdit.nameAndSurname,
        ustanovaZaposlenja: candidateEdit.institution,
      });

      dispatch({
        type: "update",
        payload: { [editCandidateFileUploadName]: candidateEdit.documentation },
      });
    }
  }, [candidateEdit]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setValuesForm((prevState, props) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Turn on/off modal
  if (!active) {
    return null;
  }

  const handleCloseBtn = () => {
    setCandidateModalEdit(false);
  };

  const handleConfirmBtn = async () => {
    if (valuesForm.evidencijskiBroj && valuesForm.imePrezime && valuesForm.ustanovaZaposlenja) {
      let form = new FormData();
      form.append("ElectionId", electionState.id);
      form.append("UserId", candidateEdit?.userId > 0 ? candidateEdit.userId : "");
      form.append("Institution", valuesForm.ustanovaZaposlenja);
      form.append("NameAndSurname", valuesForm.imePrezime);
      form.append("EvidencijskiBrojEhkms", valuesForm.evidencijskiBroj);

      if (electionState?.editCandidateDocuments === undefined) {
        form.append("documentation", []);
      } else {
        let ins = electionState.editCandidateDocuments.length;
        for (var x = 0; x < ins; x++) {
          if (electionState.editCandidateDocuments[x].fileUrl) {
          } else {
            form.append("documentation", electionState.editCandidateDocuments[x]);
          }
        }
      }
      // Loading spinner is active
      setIsLoading(true);

      let requestOptions = {
        method: "PUT",
        headers: {
          "Request-Origin": "pisarnica",
          Authorization: "Bearer " + (await getAccessToken()),
        },
        body: form,
        redirect: "follow",
      };
      fetch(
        `${process.env.REACT_APP_GATEWAY_URL}/candidate?candidateId=` + candidateEdit.id,
        requestOptions
      )
        .then((response) => {
          setFetchCandidatesTrigger((prevState) => prevState + 1);
          setIsLoading(false);
          handleCloseBtn();
        })
        .then((result) => {})
        .catch((error) => {
          setIsLoading(false);
          message.toggle({
            title: "Napomena",
            content: error,
            hideNo: true,
            yesLabel: t("modalMessage.okLabel"),
            onYes: () => {
              message.toggle({});
              handleCloseBtn();
            },
          });
        });
    } else {
      message.toggle({
        title: "Napomena",
        content: "Molimo unesite sve označene podatke.",
        hideNo: true,
        yesLabel: t("modalMessage.okLabel"),
        onYes: () => {
          message.toggle({});
        },
      });
    }
  };

  const handleFile = (uploadedFile) => {
    dispatch({
      type: "addCandidateDocsEdit",
      payload: uploadedFile,
    });
  };

  let mainModalContent = (
    <>
      {isLoading ? (
        <Loader size={`6x`} className="is-flex-grow-1 is-align-self-center" />
      ) : (
        <>
          <div className="content">
            <div>
              <h2 className="confirm-modal-mobile-header">Kandidat:</h2>
            </div>
            <div className="p-5 has-text-centered">
              <div className="confirm-modal-mobile-p is-size-5">
                <ElectionInputTxt
                  name="evidencijskiBroj"
                  isNumber={false}
                  placeholder={"Evidencijski broj"}
                  isRequired={true}
                  onChange={handleInputChange}
                  value={valuesForm?.evidencijskiBroj}
                />
              </div>
            </div>
            <div className="p-5 has-text-centered">
              <div className="confirm-modal-mobile-p is-size-5">
                <ElectionInputTxt
                  name="imePrezime"
                  isNumber={false}
                  placeholder={"Ime i prezime"}
                  isRequired={true}
                  onChange={handleInputChange}
                  value={valuesForm?.imePrezime}
                />
              </div>
            </div>
            <div className="p-5 has-text-centered">
              <div className="confirm-modal-mobile-p is-size-5">
                <ElectionInputTxt
                  name="ustanovaZaposlenja"
                  isNumber={false}
                  placeholder={"Ustanova Zaposlenja"}
                  isRequired={true}
                  onChange={handleInputChange}
                  value={valuesForm?.ustanovaZaposlenja}
                />
              </div>
            </div>
            <div className="p-5 has-text-centered">
              <div className="confirm-modal-mobile-p is-size-5">
                <ElectionFileUpload
                  placeholder={"Dodaj dokumentaciju"}
                  isRequired={false}
                  handleFile={handleFile}
                  name={editCandidateFileUploadName}
                  dispatch={dispatch}
                  electionState={electionState}
                  setFetchCandidatesTrigger={setFetchCandidatesTrigger}
                />
              </div>
            </div>
          </div>
          <div className="has-text-centered">
            <button
              className="button is-outlined ml-2 confirm-modal-vote-btn"
              id="closebtn"
              onClick={handleCloseBtn}
            >
              Odustani
            </button>
            <button
              className="button is-success ml-2 confirm-modal-vote-btn"
              id="previous"
              onClick={handleConfirmBtn}
            >
              Spremi promjene
            </button>
          </div>
        </>
      )}
    </>
  );

  return (
    <div id="modal" className={"modal is-active"}>
      <div className="modal-background"></div>
      <div className="modal-content">
        <div className="box">
          <article className="media">
            <div className="media-left"></div>
            <div style={{ overflow: "hidden" }} className="media-content">
              {mainModalContent}
            </div>
          </article>
        </div>
      </div>
    </div>
  );
};

export default CustomEditCandidate;
